<template>
  <div>质检上架</div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {};
  },

  created() {
    this.$message.error("质检上架待开发");

  },

  methods: {},
};
</script>

<style scoped lang="less"></style>
